/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SuperadminIntegrationDto } from '../../models/superadmin-integration-dto';
import { UpsertViastoriaIntegrationDto } from '../../models/upsert-viastoria-integration-dto';

export interface SuperadminControllerUpsertViastoriaIntegration$Params {
  uuid: string;
      body: UpsertViastoriaIntegrationDto
}

export function superadminControllerUpsertViastoriaIntegration(http: HttpClient, rootUrl: string, params: SuperadminControllerUpsertViastoriaIntegration$Params, context?: HttpContext): Observable<StrictHttpResponse<SuperadminIntegrationDto>> {
  const rb = new RequestBuilder(rootUrl, superadminControllerUpsertViastoriaIntegration.PATH, 'put');
  if (params) {
    rb.path('uuid', params.uuid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SuperadminIntegrationDto>;
    })
  );
}

superadminControllerUpsertViastoriaIntegration.PATH = '/superadmin/users/{uuid}/integrations/viastoria';
